import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import { searchInSample } from '../../actions/SamplePage';

const useStyles = makeStyles({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
  },
  input: {
    marginLeft: 8,
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
});

const CustomizedInputBase = ({searchKey, placeholder, searchApply, isDiabled})=> {
  const classes = useStyles();
  // const [value, setValue] = useState(searchKey);
  const [showClearIcon, setShowClearIcon] = useState(false);
  useEffect(()=>{
    setShowClearIcon((searchKey !== ""))
  }, [searchKey])
  const onChange = (evt)=>{
    // setValue(evt.target.value)
    searchApply(evt.target.value)
  }
  
  return (
    <Paper className=  {"filter-search-box " + classes.root}>
      <InputBase
        value={searchKey}
        onChange={onChange}
        className={classes.input}
        placeholder={placeholder}
        inputProps={{ 'aria-label': placeholder }}
      /><span className={showClearIcon ? "ic_close": ""}  onClick={()=>{;searchApply("")}}></span>
    </Paper>
  );
}
const mapStateToProps = (state) => ({
  searchKey:state.SamplePage.searchKey,
  placeholder:state.Language.searchPlaceholder
})

const mapDispatchToProps =(dispatch)=> {
  return {
    searchApply: (payload)=>dispatch(searchInSample(payload))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomizedInputBase);